import lodashKeyBy from 'lodash/fp/keyBy';
import lodashDefaultsDeep from 'lodash/fp/defaultsDeep';

import typeCheck from 'common/util/typeCheck';

import { hideFieldIf } from 'client/helpers/formikHelpers';

import {
  TENANT_SCREENING_CRITERIA_CREDIT_SCORE_QUALIFICATION_PER_APPLICANT,
  TENANT_SCREENING_CRITERIA_CREDIT_SCORE_QUALIFICATION_AVERAGE,
} from 'common/tenantScreeningCriteriaConstants';

export const tenantScreeningCriteriaFormFields = [
  {
    id: 'creditScore',
    title: 'Min. Credit Score',
    type: 'number',
  },
  {
    id: 'creditScoreQualification',
    title: 'How Credit Qualifies',
    type: 'select',
    properties: {
      choices: [
        {
          value: TENANT_SCREENING_CRITERIA_CREDIT_SCORE_QUALIFICATION_PER_APPLICANT,
          label: 'Per Applicant',
        },
        {
          value: TENANT_SCREENING_CRITERIA_CREDIT_SCORE_QUALIFICATION_AVERAGE,
          label: 'Avg of All Applicants',
        },
      ],
    },
  },
  {
    id: 'rentToIncomeRatio',
    title: 'Income/Rent Ratio',
    type: 'number',
  },
  {
    id: 'moveInDateRangeInDays',
    title: 'Move In Date Range',
    type: 'number',
    validations: ['required'],
  },
  {
    id: 'feloniesAccepted',
    title: 'Accept Felonies',
    type: 'yes_no',
    properties: {
      disabled: true,
    },
  },
  {
    id: 'feloniesExpirationInYears',
    title: 'Renter qualifies if felony occurred:',
    type: 'number',
    properties: {
      disabled: true,
    },
  },
  {
    id: 'bankruptciesAccepted',
    title: 'Accept Bankruptcies',
    type: 'yes_no',
  },
  {
    id: 'bankruptciesExpirationInYears',
    title: 'Renter qualifies if bankruptcy occurred:',
    type: 'number',
  },
  {
    id: 'evictionsAccepted',
    title: 'Accept Evictions',
    type: 'yes_no',
  },
  {
    id: 'evictionsExpirationInYears',
    title: 'Renter qualifies if eviction occurred:',
    type: 'number',
  },
  {
    id: 'section8Accepted',
    title: 'Enrolled in and accept Section 8?',
    type: 'yes_no',
  },
  {
    id: 'guarantorAccepted',
    title: 'Accept Guarantors',
    type: 'yes_no',
  },
  {
    id: 'guarantorRentToIncomeRatio',
    title: 'Guarantor Income/Rent ratio',
    type: 'number',
  },
  {
    id: 'verifyRentalHistory',
    title: 'Verify Rental History (VOR)',
    type: 'yes_no',
  },
  {
    id: 'verifyRentalHistoryOnMinCreditScore',
    title: 'Perform VOR when Credit is below',
    type: 'number',
  },
];

const tenantScreeningCriteraFormFieldsById = lodashKeyBy('id', tenantScreeningCriteriaFormFields);

export default function getTenantScreeningCriteriaFormFields(params) {
  typeCheck('params::NonEmptyObject', params);
  const fieldgroup = params.fieldgroup;
  const updates = params.updates || {};
  const isRequired = params.required || false;
  typeCheck('fieldgroup::NonEmptyArray', fieldgroup);

  return fieldgroup
    .filter(
      (tenantScreeningCriteriaFieldId) =>
        tenantScreeningCriteraFormFieldsById[tenantScreeningCriteriaFieldId],
    )
    .map((tenantScreeningCriteriaFieldId) => {
      const listingFormField = lodashDefaultsDeep(
        {
          ...tenantScreeningCriteraFormFieldsById[tenantScreeningCriteriaFieldId],
          validations:
            tenantScreeningCriteraFormFieldsById[tenantScreeningCriteriaFieldId].validations || [],
          properties:
            tenantScreeningCriteraFormFieldsById[tenantScreeningCriteriaFieldId].properties || {},
        },
        updates[tenantScreeningCriteriaFieldId],
      );

      if (
        isRequired &&
        !listingFormField.validations.includes('required') &&
        !listingFormField.properties.noRequired
      ) {
        listingFormField.validations.unshift('required');
      }

      return hideFieldIf(listingFormField.hideFieldIf, listingFormField);
    });
}
